var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcArj(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M20,4c1.1,0,2,0.9,2,2l0,0v12c0,1.1-0.9,2-2,2l0,0H4c-1.1,0-2-0.9-2-2l0,0L2,6c0-1.1,0.9-2,2-2l0,0H20z  M19.9,8.7h-1.6v4.2c0,0.3-0.1,0.4-0.2,0.6s-0.3,0.2-0.6,0.2c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3-0.1-0.3-0.1v1.4 c0.1,0.1,0.3,0.1,0.5,0.1c0.2,0,0.4,0.1,0.6,0.1c0.6,0,1.1-0.2,1.5-0.5c0.3-0.4,0.5-0.9,0.5-1.5V8.7z M8.1,8.7H6.5L4,15h1.6l0.5-1.3 h2.3L9,15h1.6L8.1,8.7z M13.8,8.7h-2.8V15h1.6v-2h0.9l1,2h1.6l-1.1-2.2c0.4-0.2,0.7-0.4,0.9-0.7s0.3-0.7,0.3-1.2 c0-0.7-0.2-1.2-0.6-1.6S14.5,8.7,13.8,8.7z M7.3,10.4l0.8,2.1H6.5L7.3,10.4z M13.5,10c0.3,0,0.6,0.1,0.7,0.2 c0.2,0.1,0.3,0.3,0.3,0.6c0,0.3-0.1,0.5-0.3,0.6c-0.2,0.1-0.4,0.2-0.7,0.2h-1V10H13.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArj);
export default __webpack_public_path__ + "static/media/ic_ARJ.1e432f51.svg";
export { ForwardRef as ReactComponent };